import React, { Component } from "react"
import { HeadingInitial, Paragraph, Section } from "elements"

class WhySummerCamp extends Component {
  render() {
    return (
      <div>
        <HeadingInitial>Why Summer Camp?</HeadingInitial>

        <Section>
          <Paragraph>
            A summer at camp can be one of the most rewarding experiences you
            can give a child! The opportunity to grow as a person within the
            safety of a great camp has been a life changing tradition for over
            100 years. From highly specialized camps to full summer sleep away
            camp, there is something for every child and every budget. Thousands
            of summer camps across the U.S. and Canada are searching for campers
            for the 2014 season. Camps and Campers has all kinds of camps in all
            kinds of places. Let us help you find you the perfect summer camp.
          </Paragraph>
          <Paragraph>
            Learning swimming, sports, horseback riding, boating, music, drama,
            dance, radio, computers, rock climbing and more. Campers can develop
            interest that will influence their career and educational choices
            all while having a great time. A summer at camp facilitates
            networking, leadership and life skills that prove themselves
            invaluable in all areas of responsibility. Camps and Campers has
            camp listings throughout the United States and Canada, offering your
            camper the opportunity to explore new states or Canada.
          </Paragraph>
          <Paragraph>
            Camp is the perfect way to spend the summer outdoors, in a different
            part of the country with fun people from other places. A summer at
            camp will change a life!
          </Paragraph>
        </Section>
      </div>
    )
  }
}

export default WhySummerCamp



// WEBPACK FOOTER //
// ./src/scenes/About/pages/whySummerCamp.js